export default "__VITE_ASSET__4faa5dda__"